"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FFAnalyticsData = void 0;
class FFAnalyticsData {
    static extractDlIsLoggedIn() {
        return ((dataLayer !== undefined) &&
            (dataLayer !== null) &&
            (dataLayer.length > 0) &&
            (dataLayer[0].loggedUser === true));
    }
    static extractDlDataConsentValue() {
        return (((dataLayer !== undefined) &&
            (dataLayer !== null) &&
            (dataLayer.length > 0) &&
            (dataLayer[0].data_consent !== undefined) &&
            (dataLayer[0].data_consent !== null) &&
            (dataLayer[0].data_consent !== "")) ?
            dataLayer[0].data_consent :
            null);
    }
    static extractDlUserId() {
        return (((dataLayer !== undefined) &&
            (dataLayer !== null) &&
            (dataLayer.length > 0) &&
            (dataLayer[0].userId !== undefined) &&
            (dataLayer[0].userId !== null)) ?
            dataLayer[0].userId :
            null);
    }
    static extractDlEmail() {
        return (((dataLayer !== undefined) &&
            (dataLayer !== null) &&
            (dataLayer.length > 0) &&
            (dataLayer[0].email !== undefined) &&
            (dataLayer[0].email !== null)) ?
            dataLayer[0].email :
            null);
    }
    static extractDlCoupon() {
        return (((dataLayer !== undefined) &&
            (dataLayer !== null) &&
            (dataLayer.length > 0) &&
            (dataLayer[0].couponCode !== undefined) &&
            (dataLayer[0].couponCode !== null)) ?
            dataLayer[0].couponCode :
            null);
    }
    static extractDlData() {
        return {
            isLoggedIn: FFAnalyticsData.extractDlIsLoggedIn(),
            userId: FFAnalyticsData.extractDlUserId(),
            email: FFAnalyticsData.extractDlEmail(),
            dataConsent: FFAnalyticsData.extractDlDataConsentValue(),
            coupon: FFAnalyticsData.extractDlCoupon(),
        };
    }
}
exports.FFAnalyticsData = FFAnalyticsData;
